module.exports = __webpack_public_path__ + "img/59.b12270b1.png";